import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    IAgentRequestMeetingToCompanyClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentRequestMeetingToCompanyClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/request_meeting/to_company`;

export class AgentRequestMeetingToCompanyClient implements IAgentRequestMeetingToCompanyClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, message, premium_offer, company_id } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify({
            message,
            premium_offer,
            company_id,
        });

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
